/**
 * Helper function to check if a feature flag/access should be inverted
 */
export function isInvertedCheck(value: string): boolean {
	return value.startsWith('!');
}

/**
 * Helper function to get the actual flag/access name without the inversion prefix
 */
export function getActualFlagName(value: string): string {
	return isInvertedCheck(value) ? value.slice(1) : value;
}

/**
 * Helper function to check if a feature flag is enabled (with support for inversion)
 */
export function checkFeatureFlag(
	featureFlag: string,
	featureFlags: Record<string, boolean>
): boolean {
	const actualFlag = getActualFlagName(featureFlag);
	const isInverted = isInvertedCheck(featureFlag);
	const isEnabled =
		featureFlags[actualFlag as keyof typeof featureFlags] ?? false;

	return isInverted ? !isEnabled : isEnabled;
}

/**
 * Helper function to check if a feature access is enabled (with support for inversion)
 */
export function checkFeatureAccess(
	featureAccess: string,
	featureAccessObj: any
): boolean {
	const actualAccess = getActualFlagName(featureAccess);
	const isInverted = isInvertedCheck(featureAccess);
	const isEnabled = Boolean(featureAccessObj[actualAccess]);

	return isInverted ? !isEnabled : isEnabled;
}
